// extracted by mini-css-extract-plugin
module.exports =  {"contactTablePadding":"PolicyCommonContacts_contactTablePadding__ZKuUq"};